import { Component, Input, OnInit } from '@angular/core';
import { ListService } from '../../../../shared/services/list.service';
import { UserService } from '../../../../services/user.service';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';

@Component({
  selector: 'ppl-view-timesheets',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './view-timesheets.component.html',
  styleUrl: './view-timesheets.component.css',
})
export class ViewTimesheetsComponent implements OnInit {
  programName: any;
  @Input() claimDetailId: any;
  claimTimesheetData: any[] = [];
  cols = [
    {
      field: 'timesheetId',
      header: 'Timesheet ID',
      jsonpath: 'timesheetId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerName',
      header: 'Consumer Name',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'participantPplId',
      header: 'Consumer PPL ID',
      jsonpath: 'participantPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'serviceDuration',
      header: 'Service Duration',
      jsonpath: 'serviceDuration',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnits',
      header: 'Billed Units',
      jsonpath: 'billedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidUnits',
      header: 'Paid Units',
      jsonpath: 'paidUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processingStatusDescription',
      header: 'Processing Status',
      jsonpath: 'processingStatusDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatusDescription',
      header: 'Business Status',
      jsonpath: 'businessStatusDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  constructor(
    private listService: ListService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.searchClaimTimesheetData();
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    startingPageNumber = 1
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: [
        {
          jsonPath: 'batchClaimId',
          value: this.claimDetailId,
          operator: 'Equal',
        },
      ],
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchClaimTimesheetData() {
    const processedPayload = this.buildRequestPayload(
      'billlingClmAdjTimesheets',
      'createdDate'
    );

    this.listService
      .getListData(processedPayload, 'claimadj')
      .subscribe((data: any) => {
        this.claimTimesheetData = data.responsedata;
      });
  }
}
